import React from "react";
import { Form, Nav, Button } from "react-bootstrap";
import { SEARCH_MODES, TAB_LABELS } from "../constants";

function placeholderFor(mode) {
  switch (mode) {
    case "semantic":
      return "Describe the audience (e.g. AI regulation in healthcare)";
    case "by_outlet":
      return "Outlet name, display name, or domain (e.g. Wall Street Journal)";
    default:
      return "Name or email";
  }
}

// Top-of-modal search bar. Mode tabs across the top, then a single
// horizontal row with the query input on the left and the Search button
// on the right. login_recency + max_distance used to live here as
// pre-filters; they're now post-filters in the results toolbar.
//
// All state lives in the parent RecipientPicker — this is presentational.
export default function SearchColumn({ mode, setMode, query, setQuery, onSearch, loading }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading || !query.trim()) return;
    onSearch();
  };

  return (
    <div className="border-bottom">
      {/* Mode tabs */}
      <Nav
        variant="tabs"
        activeKey={mode}
        onSelect={(k) => k && setMode(k)}
        className="recipient-picker-tabs flex-nowrap small px-3 pt-2"
      >
        {SEARCH_MODES.map((m) => (
          <Nav.Item key={m}>
            <Nav.Link eventKey={m}>{TAB_LABELS[m]}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {/* Search row. Single-line input across all modes — google-style.
          Wrapped in <Form> so Enter submits naturally via the
          type="submit" button. */}
      <Form onSubmit={handleSubmit} className="p-3">
        <div className="d-flex gap-2 align-items-center">
          <Form.Control
            type="text"
            placeholder={placeholderFor(mode)}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Button type="submit" variant="primary" disabled={loading || !query.trim()}>
            {loading ? "Searching…" : "Search"}
          </Button>
        </div>
      </Form>
    </div>
  );
}
